var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column h-100"},[_c('router-view',{key:_vm.keyUid,attrs:{"routerKey":_vm.vNodeKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }